<button
    class="btn btn-sm btn-danger"
    (click)="onKick($event); $event.stopPropagation()"
    [hidden]="
        (accountService.connectedUser | async)?.Id === params.data.Employee.Id
    "
>
    <nb-icon icon="fa-user-times"></nb-icon>
</button>
